
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f6d1a2e14413c93d$exports = {};
$f6d1a2e14413c93d$exports = JSON.parse("{\"quizzes\":[{\"title\":\"HTML\",\"icon\":\"./images/icon-html.svg\",\"questions\":[{\"question\":\"What does HTML stand for?\",\"options\":[\"Hyper Trainer Marking Language\",\"Hyper Text Marketing Language\",\"Hyper Text Markup Language\",\"Hyper Text Markup Leveler\"],\"answer\":\"Hyper Text Markup Language\"},{\"question\":\"Which of the following is the correct structure for an HTML document?\",\"options\":[\"<html><head></head><body></body></html>\",\"<head><html></html><body></body></head>\",\"<body><head></head><html></html></body>\",\"<html><body></body><head></head></html>\"],\"answer\":\"<html><head></head><body></body></html>\"},{\"question\":\"Which HTML element is used to define the title of a document?\",\"options\":[\"<head>\",\"<title>\",\"<header>\",\"<top>\"],\"answer\":\"<title>\"},{\"question\":\"What is the purpose of the <body> tag in HTML?\",\"options\":[\"It defines the document's head section.\",\"It contains all the content such as text, images, and links.\",\"It is used to define the main content of an HTML document.\",\"It specifies the body of the email content in HTML.\"],\"answer\":\"It contains all the content such as text, images, and links.\"},{\"question\":\"Which HTML tag is used to create a hyperlink?\",\"options\":[\"<hyperlink>\",\"<link>\",\"<a>\",\"<href>\"],\"answer\":\"<a>\"},{\"question\":\"Which tag is used to display images in HTML?\",\"options\":[\"<img>\",\"<image>\",\"<src>\",\"<pic>\"],\"answer\":\"<img>\"},{\"question\":\"What attribute is used to provide the path of an image in the <img> tag?\",\"options\":[\"link\",\"src\",\"href\",\"url\"],\"answer\":\"src\"},{\"question\":\"Which HTML tag is used to create an unordered list?\",\"options\":[\"<ul>\",\"<ol>\",\"<list>\",\"<li>\"],\"answer\":\"<ul>\"},{\"question\":\"What does the <br> tag do?\",\"options\":[\"It breaks the text into two sections.\",\"It creates a bold text.\",\"It inserts a line break.\",\"It adds a new row in a table.\"],\"answer\":\"It inserts a line break.\"},{\"question\":\"In HTML, what does the `fieldset` tag do?\",\"options\":[\"It is used to group related data in a form.\",\"It sets the field to a fixed size.\",\"It automatically validates the fields within a form.\",\"It hides the fields in a form.\"],\"answer\":\"It is used to group related data in a form.\"}]},{\"title\":\"CSS\",\"icon\":\"./images/icon-css.svg\",\"questions\":[{\"question\":\"What does CSS stand for?\",\"options\":[\"Colorful Style Sheets\",\"Computer Style Sheets\",\"Cascading Style Sheets\",\"Creative Style Sheets\"],\"answer\":\"Cascading Style Sheets\"},{\"question\":\"Which HTML attribute is used to define inline styles?\",\"options\":[\"styles\",\"style\",\"class\",\"font-style\"],\"answer\":\"style\"},{\"question\":\"How do you insert a comment in a CSS file?\",\"options\":[\"// this is a comment //\",\"/* this is a comment */\",\"-- this is a comment --\",\"<!-- this is a comment -->\"],\"answer\":\"/* this is a comment */\"},{\"question\":\"Which property is used to change the background color of an element?\",\"options\":[\"color\",\"bgcolor\",\"background-color\",\"background\"],\"answer\":\"background-color\"},{\"question\":\"How do you apply a style to all <p> elements?\",\"options\":[\"p { }\",\".p { }\",\"#p { }\",\"all.p { }\"],\"answer\":\"p { }\"},{\"question\":\"Which property is used to change the font of an element?\",\"options\":[\"font-style\",\"text-style\",\"font-family\",\"typeface\"],\"answer\":\"font-family\"},{\"question\":\"How do you make each word in a text start with a capital letter?\",\"options\":[\"text-transform: capitalize\",\"text-transform: uppercase\",\"text-style: capital\",\"font-transform: capitalize\"],\"answer\":\"text-transform: capitalize\"},{\"question\":\"How do you select an element with the class name 'header'?\",\"options\":[\".header\",\"#header\",\"header\",\"*header\"],\"answer\":\".header\"},{\"question\":\"What is the default value of the 'position' property?\",\"options\":[\"relative\",\"fixed\",\"absolute\",\"static\"],\"answer\":\"static\"},{\"question\":\"What is the purpose of the z-index property in CSS?\",\"options\":[\"To count the number of elements\",\"To set the magnification level of an element\",\"To specify the stack order of an element\",\"To create a zoom effect\"],\"answer\":\"To specify the stack order of an element\"}]},{\"title\":\"JavaScript\",\"icon\":\"./images/icon-js.svg\",\"questions\":[{\"question\":\"Which syntax is correct to output 'Hello World' in an alert box?\",\"options\":[\"alertBox('Hello World');\",\"msg('Hello World');\",\"alert('Hello World');\",\"msgBox('Hello World');\"],\"answer\":\"alert('Hello World');\"},{\"question\":\"How do you call a function named 'myFunction'?\",\"options\":[\"call function myFunction()\",\"call myFunction()\",\"myFunction()\",\"execute myFunction()\"],\"answer\":\"myFunction()\"},{\"question\":\"How to write an IF statement in JavaScript?\",\"options\":[\"if i = 5 then\",\"if (i == 5)\",\"if i == 5\",\"if i = 5\"],\"answer\":\"if (i == 5)\"},{\"question\":\"How to write an IF statement for executing some code if 'i' is NOT equal to 5?\",\"options\":[\"if (i <> 5)\",\"if i =! 5 then\",\"if (i != 5)\",\"if i not = 5\"],\"answer\":\"if (i != 5)\"},{\"question\":\"How does a FOR loop start?\",\"options\":[\"for (i = 0; i <= 5)\",\"for i = 1 to 5\",\"for (i <= 5; i++)\",\"for (i = 0; i <= 5; i++)\"],\"answer\":\"for (i = 0; i <= 5; i++)\"},{\"question\":\"How can you add a single-line comment in JavaScript?\",\"options\":[\"'This is a single-line comment\",\"//This is a single-line comment\",\"<!--This is a single-line comment-->\",\"/* This is a single-line comment */\"],\"answer\":\"//This is a single-line comment\"},{\"question\":\"What is the correct way to write a JavaScript array?\",\"options\":[\"var colors = (1:'red', 2:'green', 3:'blue')\",\"var colors = ['red', 'green', 'blue']\",\"var colors = 'red', 'green', 'blue'\",\"var colors = 1 = ('red'), 2 = ('green'), 3 = ('blue')\"],\"answer\":\"var colors = ['red', 'green', 'blue']\"},{\"question\":\"How do you find the number with the highest value of x and y?\",\"options\":[\"Math.ceil(x, y)\",\"top(x, y)\",\"Math.max(x, y)\",\"Math.highest(x, y)\"],\"answer\":\"Math.max(x, y)\"},{\"question\":\"Which operator is used to assign a value to a variable?\",\"options\":[\"-\",\"*\",\"=\",\"x\"],\"answer\":\"=\"},{\"question\":\"What is the correct way to write a JavaScript object?\",\"options\":[\"var person = {firstName: 'John', lastName: 'Doe'};\",\"var person = {firstName = 'John', lastName = 'Doe'};\",\"var person = (firstName: 'John', lastName: 'Doe');\",\"var person = (firstName = 'John', lastName = 'Doe');\"],\"answer\":\"var person = {firstName: 'John', lastName: 'Doe'};\"}]},{\"title\":\"Accessibility\",\"icon\":\"./images/icon-accessibility.svg\",\"questions\":[{\"question\":\"What does 'WCAG' stand for?\",\"options\":[\"Web Content Accessibility Guidelines\",\"Web Compliance Accessibility Guide\",\"Web Content Accessibility Goals\",\"Website Compliance and Accessibility Guidelines\"],\"answer\":\"Web Content Accessibility Guidelines\"},{\"question\":\"Which element is used to provide alternative text for images for screen reader users?\",\"options\":[\"<alt>\",\"<figcaption>\",\"<description>\",\"<img alt='description'>\"],\"answer\":\"<img alt='description'>\"},{\"question\":\"What does ARIA stand for in web development?\",\"options\":[\"Accessible Rich Internet Applications\",\"Advanced Responsive Internet Assistance\",\"Accessible Responsive Internet Applications\",\"Automated Responsive Internet Actions\"],\"answer\":\"Accessible Rich Internet Applications\"},{\"question\":\"Which of the following is not a principle of the WCAG?\",\"options\":[\"Perceivable\",\"Dependable\",\"Operable\",\"Understandable\"],\"answer\":\"Dependable\"},{\"question\":\"Which of these color contrast ratios defines the minimum WCAG 2.1 Level AA requirement for normal text?\",\"options\":[\"3:1\",\"4.5:1\",\"7:1\",\"2:1\"],\"answer\":\"4.5:1\"},{\"question\":\"Which of the following elements is inherently focusable, meaning it can receive focus without a 'tabindex' attribute?\",\"options\":[\"<div>\",\"<span>\",\"<a href='...'>\",\"<p>\"],\"answer\":\"<a href='...'>\"},{\"question\":\"What is the purpose of the 'lang' attribute in an HTML page?\",\"options\":[\"To specify the scripting language\",\"To define the character set\",\"To indicate the language of the page content\",\"To declare a language pack\"],\"answer\":\"To indicate the language of the page content\"},{\"question\":\"Which guideline ensures that content is accessible by keyboard as well as by mouse?\",\"options\":[\"Keyboard Accessible\",\"Mouse Independence\",\"Device Independence\",\"Operable Controls\"],\"answer\":\"Keyboard Accessible\"},{\"question\":\"What is the role of 'skip navigation' links in web accessibility?\",\"options\":[\"To skip over primary navigation to the main content\",\"To provide shortcuts to different sections of the website\",\"To help users skip unwanted sections like advertisements\",\"To bypass broken links in the navigation\"],\"answer\":\"To skip over primary navigation to the main content\"},{\"question\":\"Which of these tools can help in checking the accessibility of a website?\",\"options\":[\"W3C Validator\",\"Google Lighthouse\",\"CSS Validator\",\"JavaScript Console\"],\"answer\":\"Google Lighthouse\"}]}]}");


const $7ac4dc2976e8c9db$export$cb01edd3dbd5aa5a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f6d1a2e14413c93d$exports))).quizzes;
};
const $7ac4dc2976e8c9db$export$9fec72eeebc19c88 = (title)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f6d1a2e14413c93d$exports))).quizzes.find((quiz)=>quiz.title === title);
};


/**
 * Application state object
 * @typedef {Object} AppState
 * @property {Array} quizzes - All available quizzes
 * @property {Object|null} currentQuiz - Currently active quiz
 * @property {number} currentQuestionIndex - current question index
 * @property {number} score - Number of correct answers
 * @property {string|null} selectedAnswer - Selected answer text
 * @property {boolean} isAnswerSubmitted - Whether answer has been submitted
 */ const $ce3de23872348272$export$ca000e230c0caa3e = {
    quizzes: [],
    currentQuiz: null,
    currentQuestionIndex: 0,
    score: 0,
    selectedAnswer: null,
    isAnswerSubmitted: false
};
const $ce3de23872348272$export$cf35512e417f9253 = ()=>{
    $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz = null;
    $ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex = 0;
    $ce3de23872348272$export$ca000e230c0caa3e.score = 0;
    $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer = null;
    $ce3de23872348272$export$ca000e230c0caa3e.isAnswerSubmitted = false;
};
const $ce3de23872348272$export$94e056b32ec5f35d = (answer)=>{
    $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer = answer;
};
const $ce3de23872348272$export$51eecc3846193ba9 = ()=>{
    $ce3de23872348272$export$ca000e230c0caa3e.isAnswerSubmitted = true;
    const currentQuestion = $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions[$ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex];
    const isCorrect = $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer === currentQuestion.answer;
    if (isCorrect) $ce3de23872348272$export$ca000e230c0caa3e.score++;
    return isCorrect;
};
const $ce3de23872348272$export$12698bc319dcbbdd = ()=>{
    $ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex++;
    $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer = null;
    $ce3de23872348272$export$ca000e230c0caa3e.isAnswerSubmitted = false;
};
const $ce3de23872348272$export$9b7a4304ab7e5dd9 = ()=>{
    return $ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex >= $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions.length;
};


let $db12283b528bfe21$var$toggleSwitch = null;
const $db12283b528bfe21$export$4c47704ed26c13e8 = ()=>{
    $db12283b528bfe21$var$toggleSwitch = document.getElementById("toggle-switch-mode");
    // Check local storage for saved preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) // Use saved preference
    $db12283b528bfe21$var$applyTheme(savedTheme);
    else {
        // Check system preference
        const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        $db12283b528bfe21$var$applyTheme(prefersDark ? "dark" : "light");
    }
    // Listen for toggle clicks
    $db12283b528bfe21$var$toggleSwitch.addEventListener("change", $db12283b528bfe21$var$handleThemeToggle);
};
/**
 * Applies the theme to the document
 * @param {string} theme - "light" or "dark
 */ const $db12283b528bfe21$var$applyTheme = (theme)=>{
    const html = document.documentElement;
    if (theme === "dark") html.classList.add("dark");
    else html.classList.remove("dark");
    // Save preference
    localStorage.setItem("theme", theme);
    // Update checkbox state
    if ($db12283b528bfe21$var$toggleSwitch) $db12283b528bfe21$var$toggleSwitch.checked = theme === "dark";
};
/**
 * Handles theme toggle switch change
 * @param {*} event
 */ const $db12283b528bfe21$var$handleThemeToggle = (event)=>{
    const theme = event.target.checked ? "dark" : "light";
    $db12283b528bfe21$var$applyTheme(theme);
};
const $db12283b528bfe21$export$f89dfc8082866bac = ()=>{
    return document.documentElement.classList.contains("dark") ? "dark" : "light";
};


var $f4381be6791ad014$exports = {};
$f4381be6791ad014$exports = import.meta.resolve("avS0Y");


const $cbcb3d7a68c9b7de$var$htmlIcon = new URL($f4381be6791ad014$exports).href;
var $6cc364c64cafa5d4$exports = {};
$6cc364c64cafa5d4$exports = import.meta.resolve("c2T1M");


const $cbcb3d7a68c9b7de$var$cssIcon = new URL($6cc364c64cafa5d4$exports).href;
var $fa0048a245ea88e3$exports = {};
$fa0048a245ea88e3$exports = import.meta.resolve("1t0jr");


const $cbcb3d7a68c9b7de$var$jsIcon = new URL($fa0048a245ea88e3$exports).href;
var $5c02d82401497e7f$exports = {};
$5c02d82401497e7f$exports = import.meta.resolve("bIr1C");


const $cbcb3d7a68c9b7de$var$accessibilityIcon = new URL($5c02d82401497e7f$exports).href;
const $cbcb3d7a68c9b7de$export$df03f54e09e486fa = {
    HTML: $cbcb3d7a68c9b7de$var$htmlIcon,
    CSS: $cbcb3d7a68c9b7de$var$cssIcon,
    JavaScript: $cbcb3d7a68c9b7de$var$jsIcon,
    Accessibility: $cbcb3d7a68c9b7de$var$accessibilityIcon
};
const $cbcb3d7a68c9b7de$export$b9d7c59a579c23c6 = {
    HTML: "bg-orange-50",
    CSS: "bg-green-100",
    JavaScript: "bg-blue-50",
    Accessibility: "bg-purple-100"
};


//DOM element cache
let $f9a85cdfa1754a18$var$selectedSubjectHeader = null;
let $f9a85cdfa1754a18$var$startMenuSection = null;
let $f9a85cdfa1754a18$var$questionsSection = null;
let $f9a85cdfa1754a18$var$scoreSection = null;
const $f9a85cdfa1754a18$export$5ac527444e5e2edd = ()=>{
    $f9a85cdfa1754a18$var$selectedSubjectHeader = document.getElementById("selected-quiz-subject-header");
    $f9a85cdfa1754a18$var$startMenuSection = document.getElementById("start-menu-section");
    $f9a85cdfa1754a18$var$questionsSection = document.getElementById("questions-section");
    $f9a85cdfa1754a18$var$scoreSection = document.getElementById("score-section");
};
const $f9a85cdfa1754a18$export$f3b8e31d958a9f24 = ()=>{
    console.log("\uD83D\uDD34 showErrorMessage called");
    const errorMessage = document.getElementById("error-message");
    console.log("errorMessage element:", errorMessage);
    console.log("Classes BEFORE:", errorMessage?.className);
    errorMessage.classList.remove("hidden");
    console.log("Classes AFTER:", errorMessage?.className);
};
const $f9a85cdfa1754a18$export$333c4084290bc216 = ()=>{
    console.log("\u2705 hideErrorMessage called");
    const errorMessage = document.getElementById("error-message");
    console.log("errorMessage element:", errorMessage);
    errorMessage.classList.add("hidden");
};
const $f9a85cdfa1754a18$export$6e8aa4f269d9802c = ()=>{
    $f9a85cdfa1754a18$var$selectedSubjectHeader.classList.remove("invisible");
};
const $f9a85cdfa1754a18$export$c6ba8ebb6e6434b5 = ()=>{
    $f9a85cdfa1754a18$var$selectedSubjectHeader.classList.add("invisible");
};
const $f9a85cdfa1754a18$export$ce92632b331d8ccf = (sectionId)=>{
    const sections = {
        "start-menu-section": $f9a85cdfa1754a18$var$startMenuSection,
        "questions-section": $f9a85cdfa1754a18$var$questionsSection,
        "score-section": $f9a85cdfa1754a18$var$scoreSection
    };
    sections[sectionId]?.classList.remove("hidden");
};
const $f9a85cdfa1754a18$export$e0f58372dd4354b2 = (sectionId)=>{
    const sections = {
        "start-menu-section": $f9a85cdfa1754a18$var$startMenuSection,
        "questions-section": $f9a85cdfa1754a18$var$questionsSection,
        "score-section": $f9a85cdfa1754a18$var$scoreSection
    };
    sections[sectionId]?.classList.add("hidden");
};
const $f9a85cdfa1754a18$export$9a548410cf6c34c0 = (title)=>{
    const subjectIcon = $f9a85cdfa1754a18$var$selectedSubjectHeader.querySelector(".selected-subject-icon");
    const subjectTitle = $f9a85cdfa1754a18$var$selectedSubjectHeader.querySelector(".selected-subject-title");
    subjectIcon.src = (0, $cbcb3d7a68c9b7de$export$df03f54e09e486fa)[title];
    subjectTitle.textContent = title;
    //Update background color
    subjectIcon.classList.remove("bg-orange-50", "bg-green-100", "bg-blue-50", "bg-purple-100");
    const bgColor = (0, $cbcb3d7a68c9b7de$export$b9d7c59a579c23c6)[title];
    if (bgColor) subjectIcon.classList.add(bgColor);
};
const $f9a85cdfa1754a18$export$1e85c6cc1ce7630a = (question, questionNumber, totalQuestions)=>{
    // Update question number and text
    const questionNumberEl = document.getElementById("question-number-of");
    questionNumberEl.textContent = `Question ${questionNumber} of ${totalQuestions}`;
    const questionTextEl = document.getElementById("question-text");
    questionTextEl.textContent = question.question;
    // Update answer options
    const answerButtons = document.querySelectorAll('[role="radio"]');
    const answerLetters = [
        "A",
        "B",
        "C",
        "D"
    ];
    answerButtons.forEach((button, index)=>{
        const answerLetterSpan = button.querySelector(".answer-letter");
        const answerText = button.querySelector(".answer-text");
        answerLetterSpan.textContent = answerLetters[index];
        answerText.textContent = question.options[index];
        // Reset button state
        button.setAttribute("aria-checked", "false");
        button.classList.remove("outline-2", "outline-purple-600", "outline-green-500", "outline-red-500");
        //Reset letter background and text colors
        const letterContainer = button.querySelector(".answer-letter-container");
        letterContainer.classList.remove("bg-purple-600", "bg-green-500", "bg-red-500");
        letterContainer.classList.add("bg-grey-50");
        answerLetterSpan.classList.remove("text-white");
        answerLetterSpan.classList.add("text-grey-500");
        // Hide all icons
        const icons = button.querySelectorAll("img");
        icons.forEach((icon)=>icon.classList.add("hidden"));
    });
    // Update progress bar
    $f9a85cdfa1754a18$export$55220155eeb8e52c(questionNumber, totalQuestions);
    // Reset submit button
    $f9a85cdfa1754a18$export$e62c1937d827db0b("Submit Answer");
    $f9a85cdfa1754a18$export$333c4084290bc216();
};
const $f9a85cdfa1754a18$export$55220155eeb8e52c = (current, total)=>{
    const progressBar = document.querySelector("[role='progressbar']");
    const progressFill = document.getElementById("progress-fill");
    const percentage = current / total * 100;
    progressFill.style.width = `${percentage}%`;
    progressBar.setAttribute("aria-valuenow", Math.round(percentage));
    progressBar.setAttribute("aria-label", `${Math.round(percentage)}% Progress`);
};
const $f9a85cdfa1754a18$export$672cee525c3b8d2a = (button)=>{
    const allButtons = document.querySelectorAll('[role="radio"]');
    // Remove highlight from all buttons
    allButtons.forEach((btn)=>{
        btn.setAttribute("aria-checked", "false");
        btn.classList.remove("outline-2", "outline-purple-600");
        // Reset letter background and text - inside το button
        const letterContainer = btn.querySelector(".answer-letter-container");
        const answerLetterSpan = btn.querySelector(".answer-letter");
        letterContainer.classList.remove("bg-purple-600");
        letterContainer.classList.add("bg-grey-50");
        answerLetterSpan.classList.remove("text-white");
        answerLetterSpan.classList.add("text-grey-500");
    });
    // Highlight selected button
    button.setAttribute("aria-checked", "true");
    button.classList.add("outline-2", "outline-purple-600");
    // Change letter background to purple - inside to selected button
    const letterContainer = button.querySelector(".answer-letter-container");
    const answerLetterSpan = button.querySelector(".answer-letter");
    letterContainer.classList.remove("bg-grey-50");
    letterContainer.classList.add("bg-purple-600");
    answerLetterSpan.classList.remove("text-grey-500");
    answerLetterSpan.classList.add("text-white");
};
const $f9a85cdfa1754a18$export$35b3c4ad1f74e151 = (selectedButton, correctAnswer, isCorrect)=>{
    const allButtons = document.querySelectorAll('[role="radio"]');
    // Find the correct answer button
    let correctButton = null;
    allButtons.forEach((btn)=>{
        const answerText = btn.querySelector(".answer-text").textContent;
        if (answerText === correctAnswer) correctButton = btn;
    });
    // Show correct answer styling
    if (correctButton) {
        correctButton.classList.remove("outline-purple-600");
        correctButton.classList.add("outline-2", "outline-green-500");
        // Change letter background to green
        const letterContainer = correctButton.querySelector(".answer-letter-container");
        const letterSpan = correctButton.querySelector(".answer-letter");
        letterContainer.classList.remove("bg-grey-50", "bg-purple-600");
        letterContainer.classList.add("bg-green-500");
        letterSpan.classList.add("text-white");
        // Show correct icon (first img)
        const correctIcon = correctButton.querySelectorAll("img")[0];
        correctIcon.classList.remove("hidden");
    }
    // If user was wrong, show error styling
    if (!isCorrect && selectedButton !== correctButton) {
        selectedButton.classList.remove("outline-purple-600");
        selectedButton.classList.add("outline-2", "outline-red-500");
        // Change letter background to red
        const letterContainer = selectedButton.querySelector(".answer-letter-container");
        const letterSpan = selectedButton.querySelector(".answer-letter");
        letterContainer.classList.remove("bg-grey-50", "bg-purple-600");
        letterContainer.classList.add("bg-red-500");
        letterSpan.classList.add("text-white");
        // Show error icon (second img)
        const errorIcon = selectedButton.querySelectorAll("img")[1];
        errorIcon.classList.remove("hidden");
    }
};
const $f9a85cdfa1754a18$export$b8e61215f0d0b93b = (enabled)=>{
    const submitButton = document.getElementById("submit-answer-button");
    submitButton.disabled = !enabled;
    submitButton.setAttribute("aria-disabled", String(!enabled));
};
const $f9a85cdfa1754a18$export$e62c1937d827db0b = (text)=>{
    const submitButton = document.getElementById("submit-answer-button");
    const buttonText = submitButton.querySelector("span");
    buttonText.textContent = text;
};
const $f9a85cdfa1754a18$export$9ac1da01f55c86d1 = (quizTitle, score, totalQuestions)=>{
    // Update quiz subject in score section
    const subjectIcon = $f9a85cdfa1754a18$var$scoreSection.querySelector(".selected-subject-icon");
    const subjectTitle = $f9a85cdfa1754a18$var$scoreSection.querySelector(".selected-subject-title");
    subjectIcon.src = (0, $cbcb3d7a68c9b7de$export$df03f54e09e486fa)[quizTitle];
    subjectTitle.textContent = quizTitle;
    //Update background color
    subjectIcon.classList.remove("bg-orange-50", "bg-green-100", "bg-blue-50", "bg-purple-100");
    const bgColor = (0, $cbcb3d7a68c9b7de$export$b9d7c59a579c23c6)[quizTitle];
    if (bgColor) subjectIcon.classList.add(bgColor);
    // Update score numbers
    const scoreNumber = $f9a85cdfa1754a18$var$scoreSection.querySelector(".score-number");
    const totalText = $f9a85cdfa1754a18$var$scoreSection.querySelector(".out-of-total");
    scoreNumber.textContent = score;
    totalText.textContent = `out of ${totalQuestions}`;
    // Enable play again button
    const playAgainButton = document.getElementById("play-again-button");
    playAgainButton.disabled = false;
    playAgainButton.setAttribute("aria-disabled", "false");
};


//Initialize app
const $388b617130f03bd4$var$init = ()=>{
    // Initialize DOM
    $f9a85cdfa1754a18$export$5ac527444e5e2edd();
    // Initialize theme
    $db12283b528bfe21$export$4c47704ed26c13e8();
    // Load quiz data
    $ce3de23872348272$export$ca000e230c0caa3e.quizzes = $7ac4dc2976e8c9db$export$cb01edd3dbd5aa5a();
    // Setup event listeners
    $388b617130f03bd4$var$setupEventListeners();
};
/**
 *Set up all event listeners
 */ const $388b617130f03bd4$var$setupEventListeners = ()=>{
    // Start menu - quiz selection buttons
    const quizButtons = document.querySelectorAll("[data-subject]");
    quizButtons.forEach((button)=>{
        button.addEventListener("click", $388b617130f03bd4$var$handleQuizSelection);
    });
    // Question section - answer buttons
    const answerButtons = document.querySelectorAll('[role="radio"]');
    answerButtons.forEach((button)=>{
        button.addEventListener("click", $388b617130f03bd4$var$handleAnswerSelection);
    });
    // Question section - submit button
    const submitButton = document.getElementById("submit-answer-button");
    submitButton.addEventListener("click", $388b617130f03bd4$var$handleSubmit);
    // Score section - play again button
    const playAgainButton = document.getElementById("play-again-button");
    playAgainButton.addEventListener("click", $388b617130f03bd4$var$handlePlayAgain);
};
/**
 * Handles quiz selection from start menu
 * @param {Event} event - click event
 */ const $388b617130f03bd4$var$handleQuizSelection = (event)=>{
    const subject = event.currentTarget.dataset.subject;
    // Load selected quiz
    const quiz = $7ac4dc2976e8c9db$export$9fec72eeebc19c88(subject);
    if (!quiz) {
        console.error(`Quiz not found: ${subject}`);
        return;
    }
    // Update state
    $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz = quiz;
    $ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex = 0;
    $ce3de23872348272$export$ca000e230c0caa3e.score = 0;
    // Update UI
    $f9a85cdfa1754a18$export$e0f58372dd4354b2("start-menu-section");
    $f9a85cdfa1754a18$export$ce92632b331d8ccf("questions-section");
    $f9a85cdfa1754a18$export$9a548410cf6c34c0(quiz.title);
    $f9a85cdfa1754a18$export$6e8aa4f269d9802c();
    // Render first question
    const firstQuestion = quiz.questions[0];
    $f9a85cdfa1754a18$export$1e85c6cc1ce7630a(firstQuestion, 1, quiz.questions.length);
};
/**
 * Handles answer selection
 * @param {Event} event - Click event
 */ const $388b617130f03bd4$var$handleAnswerSelection = (event)=>{
    // Don't allow selection after submission
    if ($ce3de23872348272$export$ca000e230c0caa3e.isAnswerSubmitted) return;
    const selectedButton = event.currentTarget;
    const answerText = selectedButton.querySelector(".answer-text").textContent;
    // Update state
    $ce3de23872348272$export$94e056b32ec5f35d(answerText);
    // Update UI
    $f9a85cdfa1754a18$export$672cee525c3b8d2a(selectedButton);
    $f9a85cdfa1754a18$export$b8e61215f0d0b93b(true);
    $f9a85cdfa1754a18$export$333c4084290bc216();
};
/**
 * Handles submit button click
 */ const $388b617130f03bd4$var$handleSubmit = ()=>{
    console.log("\uD83D\uDFE1 handleSubmit called");
    console.log("Selected answer:", $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer);
    // Check if answer is selected
    if (!$ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer) {
        console.log("\u274C No answer selected, showing error");
        $f9a85cdfa1754a18$export$f3b8e31d958a9f24();
        return;
    }
    // If already submitted, move to next question
    if ($ce3de23872348272$export$ca000e230c0caa3e.isAnswerSubmitted) {
        $388b617130f03bd4$var$moveToNextQuestion();
        return;
    }
    // Submit answer
    const isCorrect = $ce3de23872348272$export$51eecc3846193ba9();
    // Get current question for correct answer
    const currentQuestion = $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions[$ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex];
    // Find selected button
    const answerButtons = document.querySelectorAll('[role="radio"]');
    let selectedButton = null;
    answerButtons.forEach((btn)=>{
        if (btn.querySelector(".answer-text").textContent === $ce3de23872348272$export$ca000e230c0caa3e.selectedAnswer) selectedButton = btn;
    });
    // Show feedback
    $f9a85cdfa1754a18$export$35b3c4ad1f74e151(selectedButton, currentQuestion.answer, isCorrect);
    // Change button text to "Next Question"
    $f9a85cdfa1754a18$export$e62c1937d827db0b("Next Question");
};
/**
 * Moves to next question or shows score
 */ const $388b617130f03bd4$var$moveToNextQuestion = ()=>{
    // Move to next question in state
    $ce3de23872348272$export$12698bc319dcbbdd();
    // Check if quiz is complete
    if ($ce3de23872348272$export$9b7a4304ab7e5dd9()) {
        $388b617130f03bd4$var$showScoreScreen();
        return;
    }
    // Render next question
    const nextQuestion = $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions[$ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex];
    const questionNumber = $ce3de23872348272$export$ca000e230c0caa3e.currentQuestionIndex + 1;
    const totalQuestions = $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions.length;
    $f9a85cdfa1754a18$export$1e85c6cc1ce7630a(nextQuestion, questionNumber, totalQuestions);
};
/**
 * Shows the final score screen
 */ const $388b617130f03bd4$var$showScoreScreen = ()=>{
    // Hide questions, show score
    $f9a85cdfa1754a18$export$e0f58372dd4354b2("questions-section");
    $f9a85cdfa1754a18$export$ce92632b331d8ccf("score-section");
    // Render score
    $f9a85cdfa1754a18$export$9ac1da01f55c86d1($ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.title, $ce3de23872348272$export$ca000e230c0caa3e.score, $ce3de23872348272$export$ca000e230c0caa3e.currentQuiz.questions.length);
};
/**
 * Handles play again button click
 */ const $388b617130f03bd4$var$handlePlayAgain = ()=>{
    // Reset state
    $ce3de23872348272$export$cf35512e417f9253();
    // Reset UI
    $f9a85cdfa1754a18$export$e0f58372dd4354b2("score-section");
    $f9a85cdfa1754a18$export$ce92632b331d8ccf("start-menu-section");
    $f9a85cdfa1754a18$export$c6ba8ebb6e6434b5();
};
// Start the app when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $388b617130f03bd4$var$init);
else $388b617130f03bd4$var$init();


//# sourceMappingURL=repo.796b8eae.js.map
